<template>
  <div v-if="items.length" style="overflow:auto">
    <table>
        <thead>
          <tr>
          <th colspan="4">
            <h2>Members Directory</h2>
          </th>
          </tr>
          <tr>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Company</th>
            <th>Chapter</th>
          </tr>
        </thead>
        <tbody>
            <tr v-for="member in items" :key="member.id">
              <td>{{ member.firstName }}</td>
              <td>{{ member.lastName }}</td>
              <td>{{ member.companyName }}</td>
              <td>{{ chapter(member) }}</td>
            </tr>
        </tbody>
    </table>
  </div>
  <div v-else>
    <div class="noMatchingItems" v-if="!loading">
      <p class="text-center">Sorry, no items match your selection.</p>
    </div>
  </div>
</template>

<script>
  export default {
      props:['items','loading','chapters'],
      methods: {
        chapter(member) {
          if (!member.membershipChapter.length ) return 'Global Director';
          return this.chapters.find(chapter=>chapter.id == member.membershipChapter[0].id).title
        }
      }
  }
</script>